var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-menu"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/mypage"}},[_c('span',[_vm._v("マイページ")])])],1),_c('li',{on:{"click":_vm.doLogout}},[_vm._v("ログアウト")])])])}
var staticRenderFns = []

export { render, staticRenderFns }